<c-modal #petDetailModal backdrop="static" size="xl" visible='true' id="petDetailModal">
  <c-modal-header>
      <h4 class="modal-title">{{ "Pet Detail" }}</h4>
      <button type="button" title="Close" [cModalToggle]="petDetailModal.id" cButtonClose (click)="closeModal()"></button>
  </c-modal-header>
  <c-modal-body>
        <form cForm [formGroup]="petDetailForm" (ngSubmit)="onSubmit()">
          <!-- Pet Information Section -->
          <c-card class="mb-4 shadow-sm border-light">
            <c-card-header class="bg-white fw-bold">Pet Information</c-card-header>
            <c-card-body>
              <!-- Pet Type & Name -->
              <c-row class="mb-3">
                <c-col md="6" class="mb-3 mb-md-0">
                  <label cLabel="col" cCol [sm]="12" for="petType">
                    Type
                  </label>
                  <c-col [sm]="12">
                    <select cFormControl formControlName="petType" aria-label="Please select a type" cSelect>
                      <option *ngFor="let pet of petTypes" [ngValue]="pet">{{pet.name}}</option>
                    </select>
                  </c-col>
                </c-col>
                <c-col md="6">
                  <label cLabel="col" cCol [sm]="12" for="name">
                    Pet Name
                  </label>
                  <c-col [sm]="12">
                    <input cFormControl formControlName="name" id="name" type="text" />
                  </c-col>
                </c-col>
              </c-row>

              <!-- Sex & last heat date -->
              <c-row [xs]="1" [xl]="2">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="">
                    Sex
                  </label>
                  <c-col [sm]="12">
                    <c-form-check [inline]="true">
                      <input cFormCheckInput  formControlName="sex" id="femaleSex" type="radio" value="F" title="Female" />
                      <label cFormCheckLabel for="femaleSex">Female</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="sex" id="maleSex" type="radio" value="M" title="Male" />
                      <label cFormCheckLabel for="maleSex">Male</label>
                    </c-form-check>
                  </c-col>
                </c-col>
                <c-col *ngIf="selectedSex==='F'">
                  <label cLabel="col" cCol [sm]="12" for="lastHeatDate">
                    If female, when was her last heat date
                  </label>
                  <c-col [sm]="12">
                    <input cFormControl formControlName="lastHeatDate" id="lastHeatDate" type="date" />
                  </c-col>
                </c-col>
              </c-row>

              <!-- Age, Breed, & Spayed/neutered -->
              <c-row [xs]="1" [xl]="3">
                <!-- Age -->
                <c-col xl="3">
                  <label cLabel="col" cCol [sm]="12" for="age">
                    Age (Months)
                  </label>
                  <c-col [sm]="12">
                    <input cFormControl formControlName="age" id="age" type="number" step="1" />
                  </c-col>
                </c-col>
                <!-- Breed -->
                <c-col xl="6">
                  <label cLabel="col" cCol [sm]="12" for="breed">
                    Breed
                  </label>
                  <c-col [sm]="12">
                    <input cFormControl formControlName="breed" id="breed" type="text" />
                  </c-col>
                </c-col>
                <!-- Spayed / neutered -->
                <c-col xl="3">
                  <label cLabel="col" cCol [sm]="12" for="">
                    Spayed / neutered
                  </label>
                  <c-col [sm]="12">
                    <c-form-check [inline]="true">
                      <input cFormCheckInput  formControlName="isSpayedNeutered" id="yesIsSpayedNeutered" type="radio" value="yes" title="Yes" />
                      <label cFormCheckLabel for="yesIsSpayedNeutered">Yes</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="isSpayedNeutered" id="noIsSpayedNeutered" type="radio" value="no" title="No" />
                      <label cFormCheckLabel for="noIsSpayedNeutered">No</label>
                    </c-form-check>
                  </c-col>
                </c-col>
              </c-row>

              <!-- is friendly -->
              <c-row [xs]="1" [xl]="2">
                <c-col xl="4">
                  <label cLabel="col" cCol [sm]="12" for="">
                    Is the pet friendly with other pets?
                  </label>
                  <c-col [sm]="12">
                    <c-form-check [inline]="true">
                      <input cFormCheckInput  formControlName="isFriendly" id="yesIsFriendly" type="radio" value="yes" title="Yes" />
                      <label cFormCheckLabel for="yesIsFriendly">Yes</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="isFriendly" id="noIsFriendly" type="radio" value="no" title="No" />
                      <label cFormCheckLabel for="noIsFriendly">No</label>
                    </c-form-check>
                  </c-col>
                </c-col>
              </c-row>

              <!-- If not friendly message -->
              <c-row [xs]="1" [xl]="1" *ngIf="selectedIsFriendly==='no'">
                <c-col xl="12">
                  <label cLabel="col" cCol [sm]="12" for="" class="danger">
                    <span class="text-danger fw-bold">Note: If not able to play with others, the pet cannot be accepted.</span>
                  </label>
                </c-col>
              </c-row>

              <!-- physical restrictions -->
              <c-row [xs]="1" [xl]="1">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="">
                    Does your pet have any physical restrictions while playing, or sensitive area on the body?
                  </label>
                  <c-col [sm]="12">
                    <c-form-check [inline]="true">
                      <input cFormCheckInput  formControlName="isSensitiveBodyOrPhysicalRestriction" id="yesIsSensitiveBodyOrPhysicalRestriction" type="radio" value="yes" title="Yes" />
                      <label cFormCheckLabel for="yesIsSensitiveBodyOrPhysicalRestriction">Yes</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="isSensitiveBodyOrPhysicalRestriction" id="noIsSensitiveBodyOrPhysicalRestriction" type="radio" value="no" title="No" />
                      <label cFormCheckLabel for="noIsSensitiveBodyOrPhysicalRestriction">No</label>
                    </c-form-check>
                  </c-col>
                </c-col>
              </c-row>

              <!-- physical restrictions explanation -->
              <c-row [xs]="1" [xl]="1" *ngIf="selectedIsSensitiveBodyOrPhysicalRestriction==='yes'">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="sensitiveBodyOrPhysicalRestrictionDetails">
                    If yes, please explain
                  </label>
                  <c-col [sm]="12">
                    <textarea cFormControl formControlName="sensitiveBodyOrPhysicalRestrictionDetails" id="sensitiveBodyOrPhysicalRestrictionDetails" rows="3"></textarea>
                  </c-col>
                </c-col>
              </c-row>
            </c-card-body>
          </c-card>

          <!-- Health Information Section -->
          <c-card class="mb-4 shadow-sm border-light">
            <c-card-header class="bg-white fw-bold">Health Information</c-card-header>
            <c-card-body>
              <!-- Fully Vaccinated -->
              <c-row [xs]="1" [xl]="2">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="">
                    Has the pet been fully vaccinated?
                  </label>
                  <c-col [sm]="12">
                    <c-form-check [inline]="true">
                      <input cFormCheckInput  formControlName="isFullyVaccinated" id="yesIsFullyVaccinated" type="radio" value="yes" title="Yes" />
                      <label cFormCheckLabel for="yesIsFullyVaccinated">Yes</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="isFullyVaccinated" id="noIsFullyVaccinated" type="radio" value="no" title="No" />
                      <label cFormCheckLabel for="noIsFullyVaccinated">No</label>
                    </c-form-check>
                  </c-col>
                </c-col>
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="vaccinatedProof">
                    Please upload proof (vaccination book or photo of book)
                  </label>
                  <c-col [sm]="12">
                    <input cFormControl formControlName="vaccinatedProof" id="vaccinatedProof" type="file" (change)="onVaccinationProofSelected($event)" />
                  </c-col>
                </c-col>
              </c-row>

              <!-- Fully Vaccinated Proof-->
              <!-- <c-row [xs]="1" [xl]="1">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="vaccinatedProof">
                    Please upload proof (vaccination book or photo of book)
                  </label>
                  <c-col [sm]="6">
                    <input cFormControl formControlName="vaccinatedProof" id="vaccinatedProof" type="file" (change)="onVaccinationProofSelected($event)" />
                  </c-col>
                </c-col>
              </c-row> -->

              <!-- Has the pet been vaccinated against rabies? -->
              <c-row [xs]="1" [xl]="1">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="">
                    Has the pet been vaccinated against rabies?
                  </label>
                  <c-col [sm]="12">
                    <c-form-check [inline]="true">
                      <input cFormCheckInput  formControlName="isRabiesVaccinated" id="yesIsRabiesVaccinated" type="radio" value="yes" title="Yes" />
                      <label cFormCheckLabel for="yesIsRabiesVaccinated">Yes</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="isRabiesVaccinated" id="noIsRabiesVaccinated" type="radio" value="no" title="No" />
                      <label cFormCheckLabel for="noIsRabiesVaccinated">No</label>
                    </c-form-check>
                  </c-col>
                </c-col>
              </c-row>

              <!-- Does the pet have any skin problems? -->
              <c-row [xs]="1" [xl]="1">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="">
                    Does the pet have any skin problems?
                  </label>
                  <c-col [sm]="12">
                    <c-form-check [inline]="true">
                      <input cFormCheckInput  formControlName="isSkinProblems" id="yesIsSkinProblems" type="radio" value="yes" title="Yes" />
                      <label cFormCheckLabel for="yesIsSkinProblems">Yes</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="isSkinProblems" id="noIsSkinProblems" type="radio" value="no" title="No" />
                      <label cFormCheckLabel for="noIsSkinProblems">No</label>
                    </c-form-check>
                  </c-col>
                </c-col>
              </c-row>

              <!-- If the pet has skin problems message-->
              <c-row [xs]="1" [xl]="1" *ngIf="selectedIsSkinProblems==='yes'">
                <c-col xl="12">
                  <label cLabel="col" cCol [sm]="12" for="" class="danger">
                    <span class="text-danger fw-bold">If the pet has a contagious skin problem, it cannot stay as all the pets play together.</span>
                  </label>
                </c-col>
              </c-row>

              <!-- Has the pet been treated for ticks and fleas? -->
              <c-row [xs]="1" [xl]="1">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="">
                    Has the pet been treated for ticks and fleas?
                  </label>
                  <c-col [sm]="12">
                    <c-form-check [inline]="true">
                      <input cFormCheckInput  formControlName="isTicksFleesTreated" id="yesIsTicksFleesTreated" type="radio" value="yes" title="Yes" />
                      <label cFormCheckLabel for="yesIsTicksFleesTreated">Yes</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="isTicksFleesTreated" id="noIsTicksFleesTreated" type="radio" value="no" title="No" />
                      <label cFormCheckLabel for="noIsTicksFleesTreated">No</label>
                    </c-form-check>
                  </c-col>
                </c-col>
              </c-row>

              <!-- Please give date of last treatment -->
              <c-row [xs]="1" [xl]="1" *ngIf="selectedIsTicksFleesTreated==='yes'">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="ticksFleesTreatedDate">
                    Please give date of last treatment
                  </label>
                  <c-col [sm]="6">
                    <input cFormControl formControlName="ticksFleesTreatedDate" id="ticksFleesTreatedDate" type="date" />
                  </c-col>
                </c-col>
              </c-row>

              <!-- Please tell us what you use to treat ticks and fleas -->
              <c-row [xs]="1" [xl]="1" *ngIf="selectedIsTicksFleesTreated==='yes'">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="ticksFleesTreatedHowTo">
                    Please tell us what you use to treat ticks and fleas
                  </label>
                  <c-col [sm]="12">
                    <textarea cFormControl formControlName="ticksFleesTreatedHowTo" id="ticksFleesTreatedHowTo" rows="3"></textarea>
                  </c-col>
                </c-col>
              </c-row>

              <!-- Has the pet been de-wormed recently?  -->
              <c-row [xs]="1" [xl]="2">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="isRecentlyDeWormed">
                    Has the pet been de-wormed recently?
                  </label>
                  <c-col [sm]="12">
                    <c-form-check [inline]="true">
                      <input cFormCheckInput  formControlName="isRecentlyDeWormed" id="yesIsRecentlyDeWormed" type="radio" value="yes" title="Yes" />
                      <label cFormCheckLabel for="yesIsRecentlyDeWormed">Yes</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="isRecentlyDeWormed" id="noIsRecentlyDeWormed" type="radio" value="no" title="No" />
                      <label cFormCheckLabel for="noIsRecentlyDeWormed">No</label>
                    </c-form-check>
                  </c-col>
                </c-col>
                <c-col *ngIf="selectedIsRecentlyDeWormed==='yes'">
                  <label cLabel="col" cCol [sm]="12" for="recentlyDeWormedDate">
                    Date
                  </label>
                  <c-col [sm]="12">
                    <input cFormControl formControlName="recentlyDeWormedDate" id="recentlyDeWormedDate" type="date" />
                  </c-col>
                </c-col>
              </c-row>

              <!-- Does the pet have any special dietary requirements?  -->
              <c-row [xs]="1" [xl]="1">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="isSpecialDietaryRequirements">
                    Does the pet have any special dietary requirements?
                  </label>
                  <c-col [sm]="12">
                    <c-form-check [inline]="true">
                      <input cFormCheckInput  formControlName="isSpecialDietaryRequirements" id="yesIsSpecialDietaryRequirements" type="radio" value="yes" title="Yes" />
                      <label cFormCheckLabel for="yesIsSpecialDietaryRequirements">Yes</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="isSpecialDietaryRequirements" id="noIsSpecialDietaryRequirements" type="radio" value="no" title="No" />
                      <label cFormCheckLabel for="noIsSpecialDietaryRequirements">No</label>
                    </c-form-check>
                  </c-col>
                </c-col>
              </c-row>

              <!-- Special dietary requirements Details  -->
              <c-row [xs]="1" [xl]="1" *ngIf="selectedIsSpecialDietaryRequirements==='yes'">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="specialDietaryRequirementsDescription">
                    If so what?
                  </label>
                  <c-col [sm]="12">
                    <textarea cFormControl formControlName="specialDietaryRequirementsDescription" id="specialDietaryRequirementsDescription" rows="3"></textarea>
                  </c-col>
                </c-col>
              </c-row>

              <!-- Has your pet been ill in the last 30 days? -->
              <c-row [xs]="1" [xl]="1">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="isIllLast30Days">
                    Has your pet been ill in the last 30 days?
                  </label>
                  <c-col [sm]="12">
                    <c-form-check [inline]="true">
                      <input cFormCheckInput  formControlName="isIllLast30Days" id="yesIsIllLast30Days" type="radio" value="yes" title="Yes" />
                      <label cFormCheckLabel for="yesIsIllLast30Days">Yes</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="isIllLast30Days" id="noIsIllLast30Days" type="radio" value="no" title="No" />
                      <label cFormCheckLabel for="noIsIllLast30Days">No</label>
                    </c-form-check>
                  </c-col>
                </c-col>
              </c-row>

              <!-- Ill in the last 30 days explanation -->
              <c-row [xs]="1" [xl]="1" *ngIf="selectedIsIllLast30Days==='yes'">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="illLast30DaysExplanation">
                    If yes, please explain
                  </label>
                  <c-col [sm]="12">
                    <textarea cFormControl formControlName="illLast30DaysExplanation" id="illLast30DaysExplanation" rows="3"></textarea>
                  </c-col>
                </c-col>
              </c-row>

              <!-- Is your pet displaying any symptoms such as coughing, sneezing, or upset stomach? -->
              <c-row [xs]="1" [xl]="1">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="isDisplayingSymptomsCoughingSneezingUpsetStomach">
                    Is your pet displaying any symptoms such as coughing, sneezing, or upset stomach?
                  </label>
                  <c-col [sm]="12">
                    <c-form-check [inline]="true">
                      <input cFormCheckInput  formControlName="isDisplayingSymptomsCoughingSneezingUpsetStomach" id="yesIsDisplayingSymptomsCoughingSneezingUpsetStomach" type="radio" value="yes" title="Yes" />
                      <label cFormCheckLabel for="yesIsDisplayingSymptomsCoughingSneezingUpsetStomach">Yes</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="isDisplayingSymptomsCoughingSneezingUpsetStomach" id="noIsDisplayingSymptomsCoughingSneezingUpsetStomach" type="radio" value="no" title="No" />
                      <label cFormCheckLabel for="noIsDisplayingSymptomsCoughingSneezingUpsetStomach">No</label>
                    </c-form-check>
                  </c-col>
                </c-col>
              </c-row>

              <!-- Do your pets have any medical conditions or has your pets had any recent injuries or illnesses? -->
              <c-row [xs]="1" [xl]="1">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="isMedicalConditionsInjuriesIllnesses">
                    Do your pets have any medical conditions or has your pets had any recent injuries or illnesses?
                  </label>
                  <c-col [sm]="12">
                    <c-form-check [inline]="true">
                      <input cFormCheckInput  formControlName="isMedicalConditionsInjuriesIllnesses" id="yesIsMedicalConditionsInjuriesIllnesses" type="radio" value="yes" title="Yes" />
                      <label cFormCheckLabel for="yesIsMedicalConditionsInjuriesIllnesses">Yes</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="isMedicalConditionsInjuriesIllnesses" id="noIsMedicalConditionsInjuriesIllnesses" type="radio" value="no" title="No" />
                      <label cFormCheckLabel for="noIsMedicalConditionsInjuriesIllnesses">No</label>
                    </c-form-check>
                  </c-col>
                </c-col>
              </c-row>

              <!-- Medical conditions, any recent injuries or illnesses details -->
              <c-row [xs]="1" [xl]="1" *ngIf="selectedIsMedicalConditionsInjuriesIllnesses==='yes'">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="medicalConditionsInjuriesIllnessesDetails">
                    If yes, please provide details including any medication, quantity & administration where required
                  </label>
                  <c-col [sm]="12">
                    <textarea cFormControl formControlName="medicalConditionsInjuriesIllnessesDetails" id="medicalConditionsInjuriesIllnessesDetails" rows="3"></textarea>
                  </c-col>
                </c-col>
              </c-row>

              <!-- Could your pets have any allergies or food sensitivities? -->
              <c-row [xs]="1" [xl]="1">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="isAllergiesFoodSensitivities">
                    Could your pets have any allergies or food sensitivities?
                  </label>
                  <c-col [sm]="12">
                    <c-form-check [inline]="true">
                      <input cFormCheckInput  formControlName="isAllergiesFoodSensitivities" id="yesIsAllergiesFoodSensitivities" type="radio" value="yes" title="Yes" />
                      <label cFormCheckLabel for="yesIsAllergiesFoodSensitivities">Yes</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="isAllergiesFoodSensitivities" id="noIsAllergiesFoodSensitivities" type="radio" value="no" title="No" />
                      <label cFormCheckLabel for="noIsAllergiesFoodSensitivities">No</label>
                    </c-form-check>
                  </c-col>
                </c-col>
              </c-row>

              <!-- Allergies or food sensitivities details -->
              <c-row [xs]="1" [xl]="1"  *ngIf="selectedIsAllergiesFoodSensitivities==='yes'">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="allergiesFoodSensitivitiesDetails">
                    If yes ,please provide details
                  </label>
                  <c-col [sm]="12">
                    <textarea cFormControl formControlName="allergiesFoodSensitivitiesDetails" id="allergiesFoodSensitivitiesDetails" rows="3"></textarea>
                  </c-col>
                </c-col>
              </c-row>
            </c-card-body>
          </c-card>

          <!-- Photo Permission -->
          <c-card class="mb-4 shadow-sm border-light">
            <c-card-header class="bg-white fw-bold">Photo Permission</c-card-header>
            <c-card-body>
              <c-row [xs]="1" [xl]="1">
                <c-col>
                  <label cLabel="col" cCol [sm]="12" for="">
                    Photo and Video Release. I agree to allow Good Dog to use my pet&apos;s name and any images or videos taken while he/she is in the care of Good Dog in any form or format, for use, at anytime, in any media, marketing, advertising, illustration, trade or promotional materials.
                  </label>
                  <c-col [sm]="12">
                    <c-form-check [inline]="true">
                      <input cFormCheckInput  formControlName="isAllowedPhotoVideoUsage" id="yesIsAllowedPhotoVideoUsage" type="radio" value="yes" title="Yes" />
                      <label cFormCheckLabel for="yesIsAllowedPhotoVideoUsage">Yes</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="isAllowedPhotoVideoUsage" id="noIsAllowedPhotoVideoUsage" type="radio" value="no" title="No" />
                      <label cFormCheckLabel for="noIsAllowedPhotoVideoUsage">No</label>
                    </c-form-check>
                  </c-col>
                </c-col>
              </c-row>
            </c-card-body>
          </c-card>
        </form>
  </c-modal-body>
  <c-modal-footer>
    <button cButton color="secondary" (click)="closeModal()">Close</button>
    <button cButton color="primary" (click)="savePetDetail()">Submit</button>
  </c-modal-footer>
</c-modal>
